import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Select, message,InputNumber, Tooltip } from 'antd';
import { useNavigate } from 'react-router-dom';
import { Row, Col } from 'antd';
import {getLocationOrigin} from '../../config/api-connect'
import * as Styled from './style.js';
import Spinner from '../../components/spinner';
import { Table, Spin } from 'antd';
import { useLocation } from 'react-router-dom';
import { DoubleLeftOutlined } from '@ant-design/icons';
import './style.css'
import { FaAngleDoubleLeft } from "react-icons/fa";


const { Option } = Select;

const AddJob = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const location = useLocation();
  const departments = location.state?.departments || [];

  const handleAddJob = async () => {
    try {
      const values = await form.validateFields();
      setSubmitLoading(true);
      const response = await fetch(`${getLocationOrigin()}/career/add_job/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
      });

      const result = await response.json();
      if (result.success) {
        message.success(result.message);
        navigate('/careers'); 
      } else {
        message.error(result?.message || 'Failed to create job');
      }
    } catch (err) {
      console.error(err);
    }
    finally{
    	setSubmitLoading(false);
    }
  };


  return (
  	<Spin spinning={loading} indicator={<Spinner />}>
      <Styled.MainContainer>
        <Styled.Header>
          <Tooltip title="Back"><a style={{cursor: 'pointer',color:'#02475c'}} onClick={()=>navigate(-1)}><FaAngleDoubleLeft/> </a></Tooltip>
          <div>Add New Job</div>
          <span></span>
        </Styled.Header>

        <Styled.FormContainer>
          <Styled.FormBody>
            <Form
              form={form}
              layout="vertical"
              style={{
                width: "100%",
                maxWidth: "600px",
                margin: "0 auto",
              }}
            >
              <Form.Item name="title" label="Title" rules={[{ required: true }]}>
                <Input style={{ borderRadius: '4px' }} />
              </Form.Item>

              <Form.Item name="location" label="Location" rules={[{ required: true }]}>
                <Input style={{ borderRadius: '4px' }} />
              </Form.Item>

              <Form.Item name="description" label="Description">
                <Input.TextArea rows={3} style={{ borderRadius: '4px' }} />
              </Form.Item>

              <Form.Item name="contact_email" label="Email">
                <Input style={{ borderRadius: '4px' }} />
              </Form.Item>

              <Form.Item name="contact_no" label="Contact No" rules={[{ required: true }]}>
                <Input style={{ borderRadius: '4px' }} />
              </Form.Item>

              <Form.Item name="minimum_qualification" label="Minimum Qualification">
                <Input style={{ borderRadius: '4px' }} />
              </Form.Item>

              <Form.Item name="experience" label="Experience">
                <Input style={{ borderRadius: '4px' }} />
              </Form.Item>

              <Form.Item name="department" label="Department" rules={[{ required: true }]}>
        			  <Select placeholder="Select Department" allowClear>
        			    {departments.map((dept) => (
        			      <Option key={dept.value} value={dept.value}>{dept.label}</Option>
        			    ))}
        			  </Select>
        			</Form.Item>

              <Form.Item name="no_of_openings" label="No of Openings" rules={[{ required: true }]}>
                <InputNumber min={0} style={{ borderRadius: '4px', width: '100%' }}/>
              </Form.Item>

              <Form.Item style={{ textAlign: 'right' }}>
                <Button type="primary" onClick={handleAddJob} loading={submitLoading} style={{ borderRadius: '4px', backgroundColor: '#006d77', borderColor: '#3c6e71' }}>
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </Styled.FormBody>
        </Styled.FormContainer>

      </Styled.MainContainer>
    </Spin>
  );
};

export default AddJob;
